import { OperationVariables } from '@apollo/client';

export const baseWhere = <T = any>(where: T, opts?: Record<string, any>): OperationVariables => ({
  variables: { where, ...opts }
});

export const baseVars = <T = any>(opts?: T): OperationVariables => ({
  variables: { ...opts }
});
